import { Sparkles, Mail, TrendingUp, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const HowItWorksSimplified = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: Sparkles,
      number: '1',
      title: t('howItWorksSimplified.step1.title'),
      description: t('howItWorksSimplified.step1.description'),
      gradient: 'from-newsletter-primary to-newsletter-secondary'
    },
    {
      icon: Mail,
      number: '2',
      title: t('howItWorksSimplified.step2.title'),
      description: t('howItWorksSimplified.step2.description'),
      gradient: 'from-newsletter-secondary to-newsletter-accent'
    },
    {
      icon: TrendingUp,
      number: '3',
      title: t('howItWorksSimplified.step3.title'),
      description: t('howItWorksSimplified.step3.description'),
      gradient: 'from-newsletter-accent to-newsletter-primary'
    }
  ];

  return (
    <div className="mb-16 animate-fade-in">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">
          {t('howItWorksSimplified.title')}
        </h2>
      </div>

      <div className="max-w-5xl mx-auto">
        <div className="relative">
          {/* Timeline line - Desktop only */}
          <div className="hidden md:block absolute top-[8rem] left-0 right-0 h-0.5 bg-gradient-to-r from-newsletter-primary via-newsletter-secondary to-newsletter-accent opacity-30" />

          <div className="grid md:grid-cols-3 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative group">
                {/* Arrow between steps - Desktop only */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-[8rem] -translate-y-1/2 -right-4 lg:-right-6 z-10">
                    <ChevronRight className="w-6 h-6 text-newsletter-primary/60" />
                  </div>
                )}

                <div className="flex flex-col items-center text-center relative z-10">
                  {/* Step number with gradient */}
                  <div className={`w-16 h-16 mb-4 rounded-full bg-gradient-to-br ${step.gradient} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <step.icon className="w-8 h-8 text-white" />
                  </div>

                  {/* Content */}
                  <div className="bg-background/50 backdrop-blur-sm border border-newsletter-primary/20 rounded-xl p-6 w-full group-hover:border-newsletter-primary/40 transition-all duration-300">
                    <h4 className="font-semibold text-lg mb-2">{step.title}</h4>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
